/* eslint-disable @typescript-eslint/quotes */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, zip } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { UserService } from "../services/user.service";


@Injectable()
export class AuthGuardUser implements CanActivate {
  constructor(
    private auth: AuthenticationService,
     private userService: UserService,
     private router : Router
     ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    const userToken = this.auth.getToken();
    const user = this.userService.getUser();
    const userRole = this.userService.getUserRole(); 

    if(userRole && userRole.includes("User")){
      return true;
    }else{
      this.router.navigate(['']);
    }

    return false;
  }
}
